import React from 'react';
import KlantenWeekAudienceTable from '../../components/klanten/KlantenWeekAudienceTable';

export default function MarketingPopupKlantenTab({
  data,
  loading,
  error,
  onRefresh,
  onOpen360,
}) {
  if (loading && !data) {
    return (
      <div className="marketing-popup-klanten-loading">
        <p className="muted">Klanten laden…</p>
        <p className="muted mpp-section-stats">Weekoverzicht wordt op de achtergrond al geladen bij openen Pop-up.</p>
      </div>
    );
  }

  return (
    <div className="marketing-popup-klanten">
      <KlantenWeekAudienceTable
        mode="marketing"
        data={data}
        loading={loading}
        error={error}
        onRefresh={onRefresh}
        onOpen360={onOpen360}
      />
    </div>
  );
}
